import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if navigation came from within the app (has state.fromApp)
    // If not, redirect to home page
    if (!location.state?.fromApp) {
      navigate('/', { replace: true });
    }
  }, [location, navigate]);

  // Only render children if navigated from within the app
  if (!location.state?.fromApp) {
    return null;
  }

  return children;
};

export default ProtectedRoute;
